import React from 'react'
import ShortAnswer from './ShortAnswer'
import SingleChoice from './SingleChoice'
import MultipleChoice from './MultipleChoice'
import Scale from './Scale'
import ScaleSmileys from './ScaleSmileys'
import Ranking from './Ranking'
// import VideoContent from './VideoContent'
// import MultipleImage from './MultipleImage'
// import SingleImage from './SingleImage'
// import ImageAnswer from './ImageAnswer/'
// import AudioRecording from './AudioRecording'
// import VideoRecording from './VideoRecording'
// import ImageContent from './ImageContent'
// import TextContent from './TextContent'
// import LinkContent from './LinkContent'
// import VideoQuestion from './VideoQuestion/'
// import DialTesting from './DialTesting'
// import Category from './Category'

const Element = ({
	item: { type, id, question, qDescription, answers, answersM, answer, labels, urls, url, thumbnail, steps, duration, answersV, answersR, orientation, textC, file, subtype, 
		dialTesting, originalUrl, options, categories}, page, setPage, limitPage} ) => {
	switch (type) {
		case 'single_choice':
			return (
				<SingleChoice
					id={id}
					question={question}
					qDescription={qDescription}
					answer={answer}
					answers={answers}
					jumpTo={answers.jumpTo}
					page={page}
					setPage={setPage}
					limitPage={limitPage}
				/>
			)
		case 'multiple_choice':
			return (
				<MultipleChoice 
					id={id} 
					question={question} 
					qDescription={qDescription} 
					answers={answers} 
					answersM={answersM} 
				/>
			)
		case 'scale':
			return (
				<Scale
					id={id}
					question={question}
					qDescription={qDescription}
					labels={labels}
					steps={steps}
					answer={answer}
					type={type}
					page={page}
					setPage={setPage}
					limitPage={limitPage}
				/>
			)
		case 'scale_nps':
			return (
				<Scale
					id={id}
					question={question}
					qDescription={qDescription}
					labels={labels}
					steps={steps}
					answer={answer}
					type={type}
					page={page}
					setPage={setPage}
					limitPage={limitPage}
				/>
			)
		case 'scale_smileys':
			return (
				<ScaleSmileys
					id={id}
					question={question}
					qDescription={qDescription}
					labels={labels}
					steps={steps}
					answer={answer}
					type={type}
					page={page}
					setPage={setPage}
					limitPage={limitPage}
				/>
			)
		// case 'video_content':
		// 	return <VideoContent 
		// 				id={id} 
		// 				question={question} 
		// 				qDescription={qDescription} 
		// 				url={url} 
		// 				thumbnail={thumbnail} 
		// 				page={page}
		// 				setPage={setPage}
		// 				limitPage={limitPage}
		// 				originalUrl={originalUrl}
		// 		/>
		// case 'image_content':
		// 	return <ImageContent 
		// 				id={id} 
		// 				question={question} 
		// 				qDescription={qDescription} 
		// 				thumbnail={thumbnail} 
		// 		/>
		// case 'link_content':	
		// 	return <LinkContent 
		// 				id={id} 
		// 				question={question} 
		// 				qDescription={qDescription} 
		// 				textC={textC}
		// 		/>	
		// case 'text_content':
		// 	return <TextContent 
		// 				id={id} 
		// 				question={question} 
		// 				qDescription={qDescription} 
		// 				textC={textC}
		// 		/>
		case 'short_answer':
			return <ShortAnswer 
						id={id} 
						question={question} 
						qDescription={qDescription} 
						answer={answer} 
				/>
		// case 'image_choice_multiple':
		// 	return <MultipleImage 
		// 				id={id} 
		// 				question={question} 
		// 				qDescription={qDescription} 
		// 				urls={urls} 
		// 				answers={answers} 
		// 		/>
		// case 'image_choice_single':
		// 	return <SingleImage
		// 				id={id} 
		// 				question={question} 
		// 				qDescription={qDescription} 
		// 				urls={urls} 
		// 				limitPage={limitPage}
		// 				page={page}
		// 				setPage={setPage}
		// 				answer={answer} 
		// 		/>
		// case 'image_answer':
		// 	return <ImageAnswer 
		// 				id={id} 
		// 				answers={answers}
		// 				url={url}
		// 				question={question} 
		// 				qDescription={qDescription}
		// 		/>
		// case 'audio_recording':
		// 	return <AudioRecording 
		// 				id={id} 
		// 				answer={answer} 
		// 				question={question} 
		// 				duration={duration} 
		// 				qDescription={qDescription}
		// 		/>
		// case 'video_recording':
		// 	return <VideoRecording 
		// 				id={id} 
		// 				answer={answer} 
		// 				question={question} 
		// 				duration={duration} 
		// 				qDescription={qDescription}
		// 		/>
		// case 'link_question':		
		// case 'video_question':
		// 	return <VideoQuestion 
		// 				id={id} 
		// 				answersV={answersV}
		// 				answer={answer}
		// 				textC={textC}
		// 				question={question} 
		// 				duration={duration} 
		// 				qDescription={qDescription}
		// 				orientation={orientation}
		// 				thumbnail={thumbnail}
		// 				url={url}
		// 				file={file}
		// 				subtype={subtype}
		// 		/>
		case 'ranking':
			return <Ranking 
						id={id} 
						question={question} 
						qDescription={qDescription}
						answersM={answersM}
						answersR={answersR}
				/>		
		// case 'video':
		// 	return <DialTesting 
		// 				id={id} 
		// 				question={question} 
		// 				qDescription={qDescription}
		// 				answer={dialTesting}
		// 				url={url}
		// 				page={page}
		// 				limitPage={limitPage}
		// 				setPage={setPage}
		// 		/>
		// case 'category':
		// 	return <Category
		// 				id={id}
		// 				question={question}
		// 				qDescription={qDescription}
		// 				categories={categories}
		// 				options={options}
		// 				answers={answers}
		// 		/>

		default:
			return null
	}
}

export default Element
